const CONTENT_FIXED_MIN_HEIGHT = 151;

export const SHOP_ABG_DEMO_HTML = `
    <template id="shop-abg-demo-landing">
        <style>
            :host {
                display: block;
                width: 100%;
                font-family: -apple-system,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif !important;
                text-align: center;
                font-style: normal !important;
            }1

            .shop-abg-iframe {
                width: 100%;
                height: 0;
                border: 0;
                margin: auto;
            }

            .shop-abg-logo {
                justify-content: center;
                align-items: center;
                padding: 16px 16px 0;
                display: flex;
            }

            .shop-abg-header {
                -webkit-font-smoothing: antialiased;
                text-align: left;
            }

            .shop-abg-header-ulc {
                text-align: center;
                padding-bottom: 0px;
                margin: 0 16px;
            }

            .shop-abg-header-title {
                letter-spacing: -0.2px;
                color: #000000;
                margin: 8px 0 16px 0;
                font-weight: 600;
                font-size: 32px;
                line-height: 120%;
            }

            .shop-abg-header-title-ulc {
                font-size: 18px;
                font-weight: 700;
                line-height: 25px;
                margin-bottom: 8px;
            }

            .shop-abg-header-description {
                font-size: 14px;
                font-weight: 400;
                color: #0F1721;
                letter-spacing: 0px;
            }

            .shop-abg-description-divider-visible {
                padding-bottom: 20px;
                border-bottom: 1px solid #D9D9D9;
            }

            .shop-abg-content--fixed {
                min-height: ${CONTENT_FIXED_MIN_HEIGHT}px;
            }

            .shop-abg-processing {
                margin: 0 20px 7px 20px;
            }

            .shop-abg-processing-user {
                color: #0F1721;
                font-family: -apple-system, BlinkMacSystemFont, San Francisco, Roboto, Segoe UI, Helvetica Neue, sans-serif;
                font-size: 12px;
                letter-spacing: 0px;
                line-height: 21px;
                margin: 12px 0;
                min-height: 21px;
                overflow: hidden;
                text-align: left;
                text-overflow: ellipsis;
                text-rendering: optimizelegibility;
                white-space: nowrap;
                -webkit-font-smoothing: antialiased;
            }

            .shop-abg {
                margin: 0;
            }

            .shop-brands {
                margin: 20px 0;
            }

            .shop-abg-text {
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0.0032em;
                color: #0B0B0C;
            }

            .shop-abg-text a {
                color: #0B0B0C;
            }

            .shop-abg,
            .shop-abg a {
                color: #424242;
            }

            .shop-abg h3 {
                font-size: 12px;
                margin: 0px 0 5px 0;
            }

            .shop-abg-disclosure {
                border: 1px solid #eee;
                border-radius: 5px;
                margin-bottom: 24px;
                padding: 10px;
                text-align: left;
            }

            .shop-abg-disclosure-text-container {
                border: none;
                width: 100%;
            }

            .shop-abg button {
                /* TODO: Centralize styling of shop branded buttons: https://github.com/Shopify/shop-identity/issues/1252 */
                border: 0;
                border-radius: 0;
                cursor: pointer;
                font: 16px/18px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica;
                margin-bottom: 2px;
                padding: 16px;
                transition: background-color 100ms ease-in-out, opacity 100ms ease-out, color 100ms ease-in-out;
                width: 100%;
            }

            .shop-abg button:last-of-type {
                margin-bottom: 0;
            }

            .shop-abg button.primary {
                background: #5433EB;
                color: #fff;
            }

            .shop-abg button.primary:hover {
                background: #7f68e9;
            }

            .shop-abg button.secondary {
                background: none;
                color: #5433EB;
            }

            .shop-abg button.secondary:hover {
                color: #7b61f0;
            }

            .shop-abg-start-free-trial-button {
              background: #000;
              color: #fff;
              border-radius: 0px;
            }

            .shop-abg-member-link {
                display: block;
                padding-bottom: 16px;
                text-decoration-line: underline;
                cursor: pointer;
            }

            .sda-hidden {
                position: absolute;
                height: 0 !important;
                border: 0;
                padding: 0;
                margin: 0;
                visibility: hidden;
                overflow: hidden;
            }

            discount-code {
                margin: 0 20px;
            }

            .shop-abg-content {
                font-weight: 400;
                font-size: 14px;
                line-height: 150%;
            }

            .shop-abg-legal {
                margin: 0;
                text-align: left;
                margin-top: 16px;
                padding-bottom: 16px;
                letter-spacing: 0.0015em;
                color: #616A75;
                font-size: 13px;
            }

            .shop-abg-member-link {
                color: #000000;
                font-size: 14px;
            }

        </style>
        <shop-sheet-modal>
            <div class="shop-abg-header">
                <h2 class="shop-abg-header-title">Save with Authentic</h2>
                <div class="shop-abg-header-description">
                    <div class="shop-abg-text">
                        Get <b>10% off and free shipping</b> on <b>every purchase</b> at over <a href="https://authentic.com/" target="_blank">40 brands</a>.
                    </div>
              </div>
            </div>
            <div class="shop-abg-content">
                <div class="shop-abg">
                    <div class="shop-abg-brands"></div>
                    <button class="shop-abg-start-free-trial-button">Start free trial</button>
                </div>
                <div class="shop-abg-legal">
                    Your Authentic membership will cost $5/month after your 30 day free trial. You can cancel anytime.
                </div>
                <a class="shop-abg-member-link">
                    Already a member?
                </a>
            </div>
        </shop-sheet-modal>
    </template>`;
